import client from './client';

export const listCustomers = (params) => client.get('/customers', { params }).then((r) => r.data);
export const pageCustomers = (params) => client.get('/customers/page', { params }).then((r) => r.data);
export const searchCustomers = (q, mine) => client.get('/customers/search', { params: { q, mine: mine ? 1 : undefined } }).then((r) => r.data);
export const getCustomer = (id) => client.get(`/customers/${id}`).then((r) => r.data);
export const customerDetail = (id) => client.get(`/customers/${id}/detail`).then((r) => r.data);
